import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, onUnmounted, ref, watch } from "vue";
import { PhArrowRight, PhSpeakerHigh } from "@phosphor-icons/vue";
import { LottieAnimation } from "lottie-web-vue";

import Breathing from "@/assets/Breathing.json";
// import DynamicGradient from "@/assets/DynamicGradient.json";
import audioFile from "@/assets/boot_assr_60s.mp3";
import { useOpenBCIUtils } from "@/utils/hooks";


export default /*@__PURE__*/_defineComponent({
  __name: 'OptimizeSignalAudioAndImpedancePanelAudioPanel',
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

// ---- STATE ----

const { sendAudioSignalStartMessage, sendAudioSignalEndMessage } =
  useOpenBCIUtils();

let anim = ref();
// let animBackground = ref();

const hasUserReadInstructions = ref(false);

let audio = new Audio(audioFile);
const isAudioPlaying = computed(
  () => hasUserReadInstructions.value && !isTimerFinished.value,
);

const progress = ref(0);
let timer: number | undefined;
const isTimerFinished = ref(false);

// ---- CALLBACKS ----

const handleContinue = async () => {
  emit("close");
};

// ---- LIFECYCLE HOOKS ----

watch(
  () => isAudioPlaying.value,
  () => {
    if (isAudioPlaying.value) {
      sendAudioSignalStartMessage();
      audio.play();
    } else {
      sendAudioSignalEndMessage();
      audio.pause();
    }
  },
);

watch(
  () => hasUserReadInstructions.value,
  () => {
    timer = setInterval(() => {
      if (progress.value < 100) {
        progress.value += 1.67; // 100 / 60 = 1.67 (approximately)
      } else {
        isTimerFinished.value = true;
        clearInterval(timer);
      }
    }, 1000);
  },
);

onUnmounted(() => {
  clearInterval(timer);
});

return (_ctx: any,_cache: any) => {
  const _component_VCol = _resolveComponent("VCol")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_VBtn = _resolveComponent("VBtn")!
  const _component_VRow = _resolveComponent("VRow")!

  return (_openBlock(), _createBlock(_component_VCol, {
    class: "flex-grow-1 d-flex h-100 pt-12",
    style: {"position":"absolute","top":"0","left":"0","bottom":"0","width":"100%","height":"100%","overflow":"hidden","z-index":"2100"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_VCol, {
        class: "position-absolute justify-center align-center",
        style: {"top":"25px","left":"25px","width":"40px","height":"40px","z-index":"2100"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_VCol, {
            class: "position-absolute justify-center align-center rounded-circle border-sm",
            style: {"top":"0px","left":"0px","width":"40px","height":"40px","z-index":"2010","background":"rgba(255, 255, 255, 0.3)","border-color":"rgba(124, 127, 122, 0.3) !important"}
          }),
          _createVNode(_unref(PhSpeakerHigh), {
            size: "24",
            style: {"z-index":"2100"},
            color: "#1a2b5a"
          })
        ]),
        _: 1
      }),
      _createVNode(_component_VCol, { class: "flex-grow-1 justify-space-between align-center" }, {
        default: _withCtx(() => [
          _cache[4] || (_cache[4] = _createElementVNode("h1", {
            class: "mb-3",
            style: {"font-size":"38px","color":"#1a2b5a"}
          }, "Please Rest", -1)),
          _createElementVNode("p", {
            class: _normalizeClass(!hasUserReadInstructions.value ? 'mb-4' : 'mb-1'),
            style: {"color":"#737373","text-align":"center","font-weight":"500","font-size":"18px","transition":"margin-bottom 0.5s ease-in-out"}
          }, _cache[1] || (_cache[1] = [
            _createTextVNode(" Turn up your volume and listen to the audio. "),
            _createElementVNode("br", null, null, -1),
            _createTextVNode(" After one minute, you can continue to the Impedance Check. ")
          ]), 2),
          _createElementVNode("p", {
            class: _normalizeClass({ deflate: hasUserReadInstructions.value }),
            style: _normalizeStyle({
          color: '#737373',
          fontWeight: '500',
          fontSize: '18px',
          minHeight: !hasUserReadInstructions.value ? '150px' : '0px',
          opacity: !hasUserReadInstructions.value ? '100%' : '0',
          maxWidth: '500px',
          textAlign: 'justify',
        })
          }, " Please breathe normally and keep your body relaxed. A baseline measurement will be recorded. After one minute, you can continue to the next step, which will be the impedance recording. ", 6),
          _createElementVNode("p", {
            class: _normalizeClass({ deflate: hasUserReadInstructions.value }),
            style: _normalizeStyle({
          color: '#737373',
          fontWeight: '500',
          fontSize: '15px',
          minHeight: !hasUserReadInstructions.value ? '30' : '0px',
          opacity: !hasUserReadInstructions.value ? '100%' : '0',
          width: '500px',
          textAlign: 'center',
        })
          }, " If you are ready, click the continue button. ", 6),
          _createVNode(_component_VCol, {
            style: _normalizeStyle({
          width: '180px',
          minHeight: hasUserReadInstructions.value ? '180px' : '0px',
        }),
            class: _normalizeClass([{ expanded: hasUserReadInstructions.value }, "mt-4 mb-8 d-flex justify-center align-center rounded-circle overflow-hidden position-relative"])
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(LottieAnimation), {
                style: {"width":"250px","justify-content":"center","align-items":"center","top":"-20px","position":"relative"},
                ref_key: "anim",
                ref: anim,
                "animation-data": _unref(Breathing),
                loop: true,
                "auto-play": true,
                speed: 1
              }, null, 8, ["animation-data"])
            ]),
            _: 1
          }, 8, ["style", "class"]),
          _createVNode(_component_VRow, {
            class: "ga-5 align-center justify-end position-relative w-100 px-8",
            style: {"min-height":"60px","background":"rgba(255, 255, 255, 0.45)","box-shadow":"0 8px 32px 0 rgba(31, 38, 135, 0.37)","backdrop-filter":"blur(10px)","-webkit-backdrop-filter":"blur(10px)"}
          }, {
            default: _withCtx(() => [
              (hasUserReadInstructions.value)
                ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                    key: 0,
                    class: "mr-auto position-absolute",
                    style: {"width":"150px","height":"5px","left":"25px","top":"50%"},
                    "model-value": progress.value,
                    rounded: "",
                    color: !isTimerFinished.value ? '#000000' : '#05775e'
                  }, null, 8, ["model-value", "color"]))
                : _createCommentVNode("", true),
              _createVNode(_component_VRow, { class: "align-start justify-center" }, {
                default: _withCtx(() => [
                  (!hasUserReadInstructions.value)
                    ? (_openBlock(), _createBlock(_component_VBtn, {
                        key: 0,
                        class: "flex-grow-0 flex-shrink-1 d-flex",
                        "append-icon": _unref(PhArrowRight),
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (hasUserReadInstructions.value = true))
                      }, {
                        default: _withCtx(() => _cache[2] || (_cache[2] = [
                          _createTextVNode("Continue")
                        ])),
                        _: 1
                      }, 8, ["append-icon"]))
                    : (_openBlock(), _createBlock(_component_VBtn, {
                        key: 1,
                        disabled: !isTimerFinished.value,
                        class: "flex-grow-0 flex-shrink-1 d-flex",
                        "append-icon": _unref(PhArrowRight),
                        onClick: handleContinue
                      }, {
                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                          _createTextVNode("Continue")
                        ])),
                        _: 1
                      }, 8, ["disabled", "append-icon"]))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})